/* unplugin-vue-components disabled */import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "page_head"
};
const _hoisted_2 = {
  style: {
    "padding": "0 0.3rem"
  }
};
const _hoisted_3 = {
  class: "select_header_box"
};
const _hoisted_4 = {
  class: "max_item_box"
};
const _hoisted_5 = {
  class: "left"
};
const _hoisted_6 = {
  class: "right"
};
const _hoisted_7 = {
  class: "count_css"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  class: "flex_center",
  style: {
    "padding-top": "1rem"
  }
};
import leftTree from "@/components/leftTree/index.vue";
import { myStudentAnalysisCount, myStudentAnalysisList, analysisCount, findAllSchoolInfoAndClass, newFileDownload } from "@/api";
import showTable from "@/views/evaluationRule/index.vue";
import userStore from "@/store/modules/user.js";
import { storeToRefs } from "pinia";
import { setScTreeValue } from "@sunrise";
import { nextTick, onActivated } from "vue";
import { ElMessage } from "element-plus";
export default {
  __name: 'index',
  setup(__props) {
    const user = userStore();
    const {
      userInfo
    } = storeToRefs(user);
    const open = ref(false);
    const indexKey = ref("all");
    const count = reactive({
      总人数: 0,
      已评价人数: 0,
      待评价人数: 0
    });
    const usernames = ref("");
    const countResize = arr => {
      count.总人数 = 0;
      count.已评价人数 = 0;
      count.待评价人数 = 0;
      arr.map(i => {
        count.总人数 += i.allCount;
        count.已评价人数 += i.evlCount;
        count.待评价人数 += i.noEvlCount;
      });
    };
    const leftData = ref([]);
    const params = reactive({
      schoolTerm: String(userInfo.value.schoolTerm),
      schoolYear: String(userInfo.value.schoolYear),
      stuName: "",
      queryType: 1,
      pageNo: 1,
      pageSize: 20,
      total: 0,
      type: "1"
    });
    const schoolYears = inject("schoolYears");
    const schoolTerms = inject("schoolTerms");
    const tableData = ref([]);
    const header = computed(() => {
      let he;
      const loadHeader = (boolean = true) => {
        if (boolean) {
          he = [{
            label: "序号",
            prop: "id"
          }, {
            label: "学段",
            prop: "schoolTypeName"
          }, {
            label: "总人数",
            prop: "allCount"
          }, {
            label: "已评价",
            children: [{
              label: "总人数",
              prop: "evlCount"
            }, {
              label: "A级",
              prop: "A"
            }, {
              label: "B级",
              prop: "B"
            }, {
              label: "C级",
              prop: "C"
            }, {
              label: "D级",
              prop: "D"
            }]
          }, {
            label: "待评价",
            prop: "noEvlCount"
          }];
        } else {
          he = [{
            label: "序号",
            prop: "id"
          }, {
            label: "班级名称",
            prop: "className"
          }, {
            label: "班主任",
            prop: "name"
          }, {
            label: "总人数",
            prop: "allCount"
          }, {
            label: "已评价",
            children: [{
              label: "总人数",
              prop: "evlCount"
            }, {
              label: "A级",
              prop: "A"
            }, {
              label: "B级",
              prop: "B"
            }, {
              label: "C级",
              prop: "C"
            }, {
              label: "D级",
              prop: "D"
            }]
          }, {
            label: "待评价",
            prop: "noEvlCount"
          }];
        }
      };
      if (params.queryType == 1) {
        loadHeader();
        he[1] = {
          label: "学段",
          prop: "schoolTypeName"
        };
      } else if (params.queryType == 2) {
        loadHeader();
        he[1] = {
          label: "学校",
          prop: "schoolName"
        };
      } else if (params.queryType == 3) {
        loadHeader();
        he[1] = {
          label: "年级",
          prop: "gradeName"
        };
      } else if (params.queryType == 4) {
        loadHeader(false);
      } else if (params.queryType == 5) {
        he = [{
          label: "序号",
          prop: "id"
        }, {
          label: "学生姓名",
          prop: "stuName"
        }, {
          label: "性别",
          prop: "sex"
        }, {
          label: "上次评价等级",
          prop: "earlyEvaluatetionLevel"
        }, {
          label: "本次评价等级",
          prop: "nowEvaluatetionLevel"
        }, {
          label: "操作",
          prop: ""
        }];
      }
      return he;
    });
    const tableValueLoadFn = arr => {
      count.总人数 = 0;
      count.已评价人数 = 0;
      count.待评价人数 = 0;
      return arr.map(i => {
        const obj = {};
        count.总人数 += i.allCount;
        count.已评价人数 += i.evlCount;
        count.待评价人数 += i.noEvlCount;
        for (const item of i.maps) {
          Object.assign(obj, item);
        }
        i.maps = obj;
        return i;
      });
    };
    let classCode = "";
    let schoolType = "";
    let schoolNum = "";
    let grade = "";
    const leftTree_c = ref(null);
    const event = reactive({
      async nodeClick(data, node) {
        console.log(node);
        params.queryType = data.queryType;
        const getValueMap = {
          async 1() {
            tableData.value = data.values;
            countResize(data.values);
          },
          async 2() {
            schoolType = data.schoolType;
            getValueMaps[2]();
          },
          async 3() {
            schoolNum = data.schoolNum;
            getValueMaps[3]();
          },
          async 4() {
            grade = data.grade;
            getValueMaps[4]();
          },
          async 5() {
            classCode = data.classCode;
            getValueMaps[5]();
          }
        };
        !!getValueMap[params.queryType] && getValueMap[params.queryType]();
        nextTick(() => {
          node.expanded = true;
          node.checked = true;
        });
      },
      imgClick(node, data) {
        console.log(node);
        const getValueMap = {
          async 1() {
            // tableData.value = data.values;
            // countResize(data.values);
          },
          async 2() {
            schoolType = data.schoolType;
          },
          async 3() {
            schoolNum = data.schoolNum;
          },
          async 4() {
            grade = data.grade;
          },
          async 5() {
            classCode = data.classCode;
          }
        };
        !!getValueMap[data.queryType] && getValueMap[data.queryType]();
        node.expanded = !node.expanded;
      }
    });
    const getValueMaps = {
      async 1() {
        const {
          code,
          data
        } = await analysisCount(params);
        console.log(code, data);
        if (code == "success") {
          tableData.value = tableValueLoadFn(data);
        }
        // tableData.value = data.values;
        // countResize(data.values);
      },
      async 2() {
        const {
          code,
          data: datas
        } = await analysisCount({
          ...params,
          schoolType
        });
        if (code == "success") {
          tableData.value = tableValueLoadFn(datas);
        }
      },
      async 3() {
        const {
          code,
          data: datas
        } = await analysisCount({
          ...params,
          schoolType,
          schoolNum
        });
        if (code == "success") {
          tableData.value = tableValueLoadFn(datas);
        }
      },
      async 4() {
        const {
          code,
          data: datas
        } = await analysisCount({
          ...params,
          schoolType,
          schoolNum,
          grade
        });
        if (code == "success") {
          tableData.value = tableValueLoadFn(datas);
        }
      },
      async 5() {
        loadBj();
        const {
          code,
          data
        } = await myStudentAnalysisCount({
          classCode,
          grade,
          schoolNum,
          schoolType,
          schoolTerm: params.schoolTerm,
          schoolYear: params.schoolYear
        });
        console.log(code, data);
        if (code == "success") {
          count.总人数 = data.allCount;
          count.已评价人数 = data.evlCount;
          count.待评价人数 = data.noEvlCount;
        }
      }
    };
    const getUserLists = async () => {
      const [treeList, TableValues] = await Promise.all([findAllSchoolInfoAndClass(), analysisCount(params)]);
      if (treeList.code == "success" && TableValues.code == "success") {
        leftData.value = [{
          label: "全县",
          queryType: 1,
          value: "all",
          values: tableValueLoadFn(TableValues.data),
          schoolInfoVoList: setScTreeValue(treeList.data, TableValues.data, 1 + 1)
        }];
        tableData.value = TableValues.data;
        console.log(leftData.value, "tableData.value");
        // leftTree_c.value.resize();
      }
    };
    const router = useRouter();
    getUserLists();
    const studentData = ref({});
    const toDetails = async row => {
      // open.value = true;
      const {
        userName,
        stuUserName
      } = row;
      usernames.value = row.stuName;
      studentData.value = {
        classCode,
        noDownload: 1,
        schoolNum,
        schoolTerm: params.schoolTerm,
        schoolYear: params.schoolYear,
        userName,
        stuName: row.stuName,
        sex: row.sex
        // userName,
      };
      console.log(row, "row");
      router.push({
        name: "userDetails",
        query: {
          stuUserName: userName,
          schoolTerm: params.schoolTerm,
          schoolYear: params.schoolYear,
          stuName: row.stuName,
          schoolNum
        }
      });

      // const { code, data } = await newFileDownload(query);
      // console.log(code, data);
      // if (code == "success") {
      //   const { list } = data;
      //   ca.value = caValuesList(list);
      // }
    };
    const handleClick = val => {
      params.type = val.paneName;
      loadBj();
    };
    const loadBj = async () => {
      const {
        code,
        data: datas
      } = await myStudentAnalysisList({
        ...params,
        classCode
      });
      if (code == "success") {
        const {
          rows,
          total
        } = datas;
        tableData.value = rows;
        params.total = total;
      }
    };
    const currentChange = val => {
      params.pageNo = val;
      getValueMaps[params.queryType]();
    };
    const yearFn = () => {
      getValueMaps[params.queryType]();
    };
    const terms = () => {
      getValueMaps[params.queryType]();
    };
    const selectName = () => {
      if (params.queryType != 5) {
        ElMessage.warning("请选择班级！");
        return;
      }
      getValueMaps[params.queryType]();
    };
    return (_ctx, _cache) => {
      const _component_head_title = _resolveComponent("head-title");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("main", _hoisted_1, [_createVNode(_component_head_title, {
        title: "综合素养评价分析"
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_select, {
        modelValue: _unref(params).schoolYear,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(params).schoolYear = $event),
        placeholder: "学年",
        onChange: yearFn
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(schoolYears), item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_select, {
        modelValue: _unref(params).schoolTerm,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(params).schoolTerm = $event),
        placeholder: "学期",
        onChange: terms
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(schoolTerms), item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_input, {
        modelValue: _unref(params).stuName,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(params).stuName = $event),
        placeholder: "请输入学生姓名",
        clearable: ""
      }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: selectName
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("搜索", -1)]))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(leftTree, _mergeProps({
        ref_key: "leftTree_c",
        ref: leftTree_c
      }, {
        att: {
          data: _unref(leftData),
          currentNodeKey: 'all',
          nodeKey: 'value',
          defaultExpandAll: false,
          props: {
            label: 'label',
            value: 'value',
            children: 'schoolInfoVoList'
          }
        },
        event: _unref(event)
      }), null, 16)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(count), (v, i) => {
        return _openBlock(), _createElementBlock("span", {
          key: i
        }, [_createElementVNode("h1", null, _toDisplayString(v), 1), _createElementVNode("div", null, _toDisplayString(i), 1)]);
      }), 128))]), _createElementVNode("div", {
        class: "table_box",
        style: _normalizeStyle({
          '--tabs_height': _unref(params).queryType == 5 ? '102px' : '0px'
        })
      }, [_unref(params).queryType == 5 ? (_openBlock(), _createBlock(_component_el_tabs, {
        key: 0,
        modelValue: _unref(params).type,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(params).type = $event),
        class: "demo-tabs",
        onTabClick: handleClick
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "已评价",
          name: ""
        }), _createVNode(_component_el_tab_pane, {
          label: "待评价",
          name: "1"
        })]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(_component_el_table, {
        stripe: "",
        data: _unref(tableData),
        style: {
          "width": "100%",
          "height": "100%"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(header), ({
          children = [],
          ...att
        }, i) => {
          return _openBlock(), _createElementBlock(_Fragment, null, [!children.length ? (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
            key: 0,
            ref_for: true
          }, att, {
            align: "center"
          }), {
            default: _withCtx(({
              row,
              $index
            }) => [att.prop == 'id' ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($index + 1), 1)) : _createCommentVNode("", true), att.prop == '' ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              onClick: $event => toDetails(row),
              style: {
                "color": "#4ebdf1",
                "cursor": "pointer"
              }
            }, " 本次评价明细 ", 8, _hoisted_9)) : _createCommentVNode("", true)]),
            _: 2
          }, 1040)) : (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
            key: 1,
            ref_for: true
          }, att, {
            align: "center"
          }), {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(children, (item, index) => {
              return _openBlock(), _createBlock(_component_el_table_column, _mergeProps({
                key: 'children' + index,
                align: "center"
              }, {
                ref_for: true
              }, item), {
                default: _withCtx(({
                  row
                }) => [item.prop == 'evlCount' ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(row?.evlCount), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(!!row?.maps ? row?.maps[item.prop] : 0), 1))]),
                _: 2
              }, 1040);
            }), 128))]),
            _: 2
          }, 1040))], 64);
        }), 256))]),
        _: 1
      }, 8, ["data"]), _createElementVNode("div", _hoisted_12, [_unref(params).queryType == 5 ? (_openBlock(), _createBlock(_component_el_pagination, {
        key: 0,
        background: "",
        layout: "prev, pager, next",
        total: _unref(params).total,
        "page-size": 20,
        onCurrentChange: currentChange
      }, null, 8, ["total"])) : _createCommentVNode("", true)])], 4)])])]), _createVNode(_component_el_dialog, {
        title: '评价明细',
        width: "60%",
        modelValue: _unref(open),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(open) ? open.value = $event : null),
        class: "dialog",
        "append-to-body": "",
        "destroy-on-close": ""
      }, {
        default: _withCtx(() => [_createVNode(showTable, {
          studentData: _unref(studentData)
        }, null, 8, ["studentData"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};